<template>
    <section id="features" class="features-area">

        <div class="bubble-box">
            <div class="bubbles-1"></div>
            <div class="bubbles-2"></div>
            <div class="bubbles-3"></div>
            <div class="bubbles-4"></div>
            <div class="bubbles-5"></div>
            <div class="bubbles-7"></div>
        </div>

        <div class="container">

            <SectionContent :title="pageData.title" :subHeading="pageData.subheading" /> 


            <!-- All Features Wrapper-->
            <div class="row all-features-wrapper">

                <!--Single Feature box Start-->
                <div class="col-12 col-sm-12 col-md-4" v-for="(data, index) of features" :key="index">
                    <div class="single-features wow fadeInLeft" data-wow-duration="1.0s" data-wow-delay=".4s">

                        <div class="hover-content"></div>
                        <div class="icon-wave-bg" v-if="data.icon">
                            <img :src="`${filePath}/${data.icon}`" :alt="data.heading">                            
                        </div>
                        <div class="single-feature-content">
                            <h4>{{ data.heading }}</h4>
                            <p>{{ data.short_content }}</p>
                        </div>
                    </div>
                </div>
                <!--Single Feature box End-->


            </div>
            <!-- All Features Wrapper-->
        </div>

    </section>
</template>

<script>
import SectionContent from '../../components/Section-Content'

export default {    
    components: { SectionContent },
    data(){
        return {
            features: {},
            pageData: {},
            filePath: ''
        }
    },
    methods: {
        async getData(){
            this.$http.get(`/features`).then(res=>{                
                if(res.status === 200 && res.data.result){
                    this.features = res.data.result
                    this.filePath = res.data.file_path
                    this.pageData = res.data.page_data
                }
            })
        }
    },
    created: function(){
        this.getData()
    }
}
</script>